<div class="d-flex flex-column h-100 w-100">
  <!--Header-->
  <div *ngIf="model" class="header d-flex flex-row px-3 pt-1 w-100 align-items-center">
    <div class="p-2">
      <span *ngIf="!catalogMainImage" class="glyphicon glyphicon-picture"></span>
      <img *ngIf="catalogMainImage" src="{{ catalogMainImage }}" />
    </div>

    <div class="p-2 flex-fill">
      <h5>{{ model.catalogName }}</h5>
      <h6>
        {{ model.catalogVersion ? 'Version: ' + model.catalogVersion : '' }} vom {{ model.date | date : 'dd.MM.yyyy' }}
      </h6>
    </div>

    <div *ngIf="modelService.loginService.hasAddonDATA_QUALITY" class="p-2 data-quality-header">
      <div class="data-quality-card">
        <div class="data-quality-refresh">
          <dx-button
            *ngIf="!isDataQualityPieChartEmpty && isCatalogDataQualityUpToDate"
            class="refreshIconUpToDate"
            hint="{{ 'Datenqualität aktuell' | translate }}"
            icon="refresh"
            height="36"
            width="36"
            stylingMode="text"
            (onClick)="calculateDataQuality()"
          ></dx-button>

          <dx-button
            *ngIf="isDataQualityPieChartEmpty"
            class="refreshIconNotCalculated"
            hint="{{ 'Datenqualität nicht berechnet' | translate }}"
            icon="refresh"
            height="36"
            width="36"
            stylingMode="text"
            (onClick)="calculateDataQuality()"
          ></dx-button>

          <dx-button
            *ngIf="!isDataQualityPieChartEmpty && !isCatalogDataQualityUpToDate"
            class="refreshIconNotUpToDate"
            hint="{{ 'Datenqualität nicht aktuell' | translate }}"
            icon="refresh"
            height="36"
            width="36"
            stylingMode="text"
            (onClick)="calculateDataQuality()"
          ></dx-button>
        </div>

        <div class="data-quality-chart">
          <dx-pie-chart
            [dataSource]="dataQualityPieChartDataSource"
            type="doughnut"
            [startAngle]="90"
            [resolveLabelOverlapping]="'shift'"
            [palette]="dataQualityPieChartColorPalette"
            (onPointClick)="onGroupClicked($event)"
          >
            <dxi-series argumentField="category" valueField="productCount"></dxi-series>
            <dxo-size [width]="120" [height]="120"></dxo-size>
            <dxo-legend [visible]="false"></dxo-legend>
            <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeDataQualityPieTooltip" />
          </dx-pie-chart>
        </div>

        <dx-button
          class="dx-button-text-left"
          width="100%"
          icon="export"
          text="{{ 'Datenqualität' | translate }}"
          hint="{{ 'Zur Datenqualität springen' | translate }}"
          stylingMode="text"
          (onClick)="jumpToCatalogDataQuality()"
        ></dx-button>
      </div>
    </div>
  </div>

  <!-- Details -->
  <div class="catalog-sticky-toolbar" style="margin-left: 130px;">
    <dx-toolbar class="np-toolbar-icon-top">
      <dxi-item *ngIf="renderMakrosButton()" location="before" locateInMenu="auto" template="makrosButton"></dxi-item>
      <dxi-item *ngIf="renderReimportButton()" location="before" locateInMenu="auto" template="reimportButton"></dxi-item>
      <dxi-item *ngIf="renderExportButton()" location="before" locateInMenu="auto" template="exportButton"></dxi-item>
      <dxi-item *ngIf="renderTranslateButton()" location="before" locateInMenu="auto" template="translateButton"></dxi-item>

      <dxi-item
        *ngIf="renderCategoryImportButton()"
        location="before"
        locateInMenu="auto"
        template="categoryImportButton"
      ></dxi-item>
      <dxi-item
        *ngIf="renderCategoryExportButton()"
        location="before"
        locateInMenu="auto"
        template="categoryExportButton"
      ></dxi-item>
      <dxi-item
        *ngIf="renderMassDataChangeButton()"
        location="before"
        locateInMenu="auto"
        template="massDataChangeButton"
      ></dxi-item>

      <!-- Templates -->
      <div *dxTemplate="let toolbarItem of 'makrosButton'">
        <dx-button
          class="np-toolbar-icon-button"
          stylingMode="text"
          type="default"
          (onClick)="showUserActions()"
        >
          <div class="np-toolbar-icon-button_content">
            <img class="np-toolbar-icon-button_icon" src="/images/macro_gear.svg" alt="" />
            <span class="np-toolbar-icon-button_text">{{ 'Makros' | translate }}</span>
          </div>
        </dx-button>
      </div>

      <div *dxTemplate="let toolbarItem of 'reimportButton'">
        <dx-button
        class="np-toolbar-icon-button"
          stylingMode="text"
          type="default"
          (onClick)="showImportCatalog()"
        >
          <div class="np-toolbar-icon-button_content">
            <img class="np-toolbar-icon-button_icon" src="/images/reimport.svg" alt="" />
            <span class="np-toolbar-icon-button_text">{{ 'Reimport' | translate }}</span>
          </div>
        </dx-button>
      </div>

      <div *dxTemplate="let toolbarItem of 'exportButton'">
        <dx-button
        class="np-toolbar-icon-button"
          stylingMode="text"
          type="default"
          (onClick)="showExport()"
        >
          <div class="np-toolbar-icon-button_content">
            <img class="np-toolbar-icon-button_icon" src="images/export.svg" alt="" />
            <span class="np-toolbar-icon-button_text">{{ 'Export' | translate }}</span>
          </div>
        </dx-button>
      </div>

      <div *dxTemplate="let toolbarItem of 'translateButton'">
        <dx-button
          class="np-toolbar-icon-button"
          stylingMode="text"
          type="default"
          (onClick)="showTranslate()"
        >
          <div class="np-toolbar-icon-button_content">
            <img class="np-toolbar-icon-button_icon" src="/images/translate.svg" alt="" />
            <span class="np-toolbar-icon-button_text">{{ 'Übersetzung' | translate }}</span>
          </div>
        </dx-button>
      </div>

      <div *dxTemplate="let toolbarItem of 'categoryImportButton'">
        <dx-button
          class="np-toolbar-icon-button"
          stylingMode="text"
          type="default"
          (onClick)="showCategoryImport()"
        >
          <div class="np-toolbar-icon-button_content">
            <img class="np-toolbar-icon-button_icon" src="/images/kategorie_import.svg" alt="" />
            <span class="np-toolbar-icon-button_text">{{ 'Kategorieimport' | translate }}</span>
          </div>
        </dx-button>
      </div>
      <div *dxTemplate="let toolbarItem of 'categoryExportButton'">
        <dx-button
          class="np-toolbar-icon-button"
          stylingMode="text"
          type="default"
          (onClick)="showCategoryExport()"
        >
          <div class="np-toolbar-icon-button_content">
            <img class="np-toolbar-icon-button_icon" src="/images/kategorie_export.svg" alt="" />
            <span class="np-toolbar-icon-button_text">{{ 'Kategorieexport' | translate }}</span>
          </div>
        </dx-button>
      </div>

      <div *dxTemplate="let toolbarItem of 'massDataChangeButton'">
        <dx-button
          class="np-toolbar-icon-button"
          stylingMode="text"
          type="default"
          (onClick)="openMassDataChange()"
        >
          <div class="np-toolbar-icon-button_content">
            <img class="np-toolbar-icon-button_icon" src="/images/massendaten.svg" alt="" />
            <span class="np-toolbar-icon-button_text">{{ 'Massendatenänderung' | translate }}</span>
          </div>
        </dx-button>
      </div>
    </dx-toolbar>
  </div>

  <div class="catalog-details-container flex-fill d-flex flex-column min-h-0">
    <dx-validation-group
      (initialized)="validateCatalog"
      id="catalogValidationGroup"
      class="flex-fill d-flex flex-column min-h-0"
    >
      <div class="catalog-tabpanel-wrapper flex-fill min-h-0">
        <dx-tab-panel
          class="np-vertical-tabs h-100"
          [keyExpr]="'id'"
          [dataSource]="pages"
          [selectedIndex]="currentTabIndex"
          [swipeEnabled]="false"
          [tabsPosition]="'left'"
          (onSelectionChanged)="onTabChange($event)">
          <!--INFOS-->
          <div *dxTemplate="let company of 'katalogTemplate'">
            <div class="np-form-control dx-fieldset mainInfos" *ngIf="model">
              <div class="container-fluid px-0">
                <div class="row g-3">
                  <!-- Zeile 1 -->
                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(0)" (mouseleave)="ttt(0)">
                        {{ 'Katalogname' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt0"
                      >
                        <label class="placeLabel {{ model.catalogName?.length>0 ? 'placeLabelSmall' : '' }}">CATALOG_NAME</label>

                        <dx-text-box
                          id="catalogName"
                          [readOnly]="readOnly('catalogName')"
                          [(value)]="model.catalogName"
                          [showClearButton]="true"
                          valueChangeEvent="focusout"
                          (onValueChanged)="catalogUpdate($event)"
                        >
                          <dx-validator validationGroup="catalogValidationGroup">
                            <dxi-validation-rule
                              type="required"
                              message="{{ 'Bitte geben Sie einen Katalognamen an' | translate }}!"
                            ></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>

                      <dx-tooltip target="#tt0" class="toolTip toolTipField" [(visible)]="v[0]">
                        <div *dxTemplate="let data = data of 'content'">
                          <p>{{ 'Der Katalogname wird in der Katalogübersicht angezeigt' | translate }}.</p>
                          <p>{{ 'Der Katalogname gibt bei nexMart die oberste Kategorie an' | translate }}.</p>
                          <p>{{ 'Bsp.: Herbst/Winter' | translate }}2005/2006</p>
                          <div *ngIf="showProToolTips" class="nexMartTooltip">
                            {{ 'Technisch gibt es keine Besonderheiten' | translate }}.
                          </div>
                        </div>
                      </dx-tooltip>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(1)" (mouseleave)="ttt(1)">
                        {{ 'Katalog-Version' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt1"
                      >
                        <label class="placeLabel {{ model.catalogVersion?.length>0 ? 'placeLabelSmall' : '' }}">CATALOG_VERSION</label>

                        <dx-text-box
                          id="catalogVersion"
                          [readOnly]="readOnly('catalogVersion')"
                          [(value)]="model.catalogVersion"
                          [showClearButton]="true"
                          valueChangeEvent="focusout"
                          (onValueChanged)="catalogUpdate($event)"
                        >
                        </dx-text-box>
                      </div>

                      <dx-tooltip target="#tt1" class="toolTip toolTipField" [(visible)]="v[1]">
                        <div *dxTemplate="let data = data of 'content'">
                          <p>{{ 'Die Katalogversion wird in der Katalogübersicht angezeigt' | translate }}.</p>
                          <p>
                            {{ 'Format: “MajorVersion“' | translate }}.
                            {{ '“MinorVersion“ (maximal jedoch ' | translate }}xxx.yyy)
                          </p>
                          <p>{{ 'Beispiel' | translate }}:<br />001.120<br />7.3</p>
                          <div *ngIf="showProToolTips" class="nexMartTooltip">
                            {{ 'Technisch gibt es keine Besonderheiten' | translate }}.
                          </div>
                        </div>
                      </dx-tooltip>
                    </div>
                  </div>

                  <!-- Zeile 2 -->
                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(2)" (mouseleave)="ttt(2)">
                        {{ 'Gruppierung' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt2"
                      >
                        <label class="placeLabel {{ model.pimGroup?.length>0 ? 'placeLabelSmall' : '' }}">CATALOG_GROUP</label>

                        <dx-autocomplete
                          [minSearchLength]="0"
                          [dataSource]="modelService.catalogService.catalogGroupList"
                          [showClearButton]="true"
                          [showDropDownButton]="true"
                          valueChangeEvent="blur"
                          (onValueChanged)="updateCatalogGroup()"
                          [(value)]="model.pimGroup"
                          [readOnly]="readOnly('catalogGroup')"
                        >
                        </dx-autocomplete>
                      </div>

                      <dx-tooltip target="#tt2" class="toolTip toolTipField" [(visible)]="v[2]">
                        <div *dxTemplate="let data = data of 'content'">
                          <p>{{ 'Nach der Gruppe wird in der Katalogübersicht sortiert' | translate }}.</p>
                          <div *ngIf="showProToolTips" class="nexMartTooltip">
                            {{ 'Technisch gibt es keine Besonderheiten' | translate }}.
                          </div>
                        </div>
                      </dx-tooltip>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(3)" (mouseleave)="ttt(3)">
                        {{ 'Katalog-ID' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt3"
                      >
                        <label class="placeLabel {{ model.catalogId?.length>0 ? 'placeLabelSmall' : '' }}">CATALOG_ID</label>

                        <dx-text-box
                          id="catalogId"
                          [readOnly]="readOnly('catalogId')"
                          [(value)]="model.catalogId"
                          [showClearButton]="true"
                          valueChangeEvent="focusout"
                          (onValueChanged)="catalogIdUpdate($event)"
                        >
                          <dx-validator validationGroup="catalogIdValidationGroup">
                            <dxi-validation-rule
                              type="async"
                              message="{{ 'Es existiert mindestens ein Katalog mit der gleichen Id!' | translate }}"
                              [validationCallback]="validateCatalogId"
                            ></dxi-validation-rule>
                          </dx-validator>
                        </dx-text-box>
                      </div>

                      <dx-tooltip target="#tt3" class="toolTip toolTipField" [(visible)]="v[3]">
                        <div *dxTemplate="let data = data of 'content'">
                          <p>
                            {{
                              'Eindeutiger Identifikator des Kataloges; dieser wird normalerweise vom Lieferanten bei der ersten Katalogerstellung vergeben und verändert sich über den gesamten Lebenszyklus des Kataloges nicht'
                                | translate
                            }}.
                          </p>
                          <div *ngIf="showProToolTips" class="nexMartTooltip">
                            {{ 'Technisch gibt es keine Besonderheiten' | translate }}.
                          </div>
                        </div>
                      </dx-tooltip>
                    </div>
                  </div>

                  <!-- Zeile 3 -->
                  <div class="col-12 col-lg-6">
                    <div
                      class="dx-field"
                      *ngIf="modelService.loginService.isAdmin && modelService.loginService.hasAddonDEVELOPMENT"
                    >
                      <div class="dx-field-label dx-field-label200">{{ 'Objekt ID' | translate }}</div>
                      <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                        <dx-text-box [value]="model.id"></dx-text-box>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="dx-field masterCatalogInline" style="margin-top: 28px;" *ngIf="!model.isVirtual">
                      <div class="dx-field-label">{{ 'Master Katalog' | translate }}</div>

                      <div class="dx-field-value">
                        <dx-switch
                          [(value)]="model.isActivId"
                          [readOnly]="readOnly('catalogVersion')"
                          switchedOffText="{{ 'Ja' | translate }}"
                          switchedOnText="{{ 'Nein' | translate }}"
                          (onValueChanged)="catalogIdUpdate($event)"
                          validationMessagePosition="left"
                        >
                          <dx-validator validationGroup="catalogIdValidationGroup">
                            <dxi-validation-rule
                              type="async"
                              message="{{ 'Es existiert mindestens ein Katalog mit der gleichen Id!' | translate }}"
                              [validationCallback]="validateCatalogId"
                            ></dxi-validation-rule>
                          </dx-validator>
                        </dx-switch>
                      </div>
                    </div>
                  </div>

                  <!-- Zeile 4 -->
                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label">{{ 'Katalogstatus' | translate }}</div>
                      <div class="dx-field-value">
                        <dx-tag-box
                          [(value)]="model.catalogState"
                          [items]="catalogStates"
                          [acceptCustomValue]="true"
                          (onValueChanged)="updateState($event, 'CATALOG_STATUS')"
                          [readOnly]="readOnly('catalogState')"
                          noDataText=""
                          placeholder=""
                        >
                        </dx-tag-box>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(4)" (mouseleave)="ttt(4)">
                        {{ 'Währung' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt4"
                      >
                        <label class="placeLabel {{ model?.currency?.length>0 ? 'placeLabelSmall' : '' }}">CATALOG_CURRENCY</label>

                        <dx-autocomplete
                          [minSearchLength]="0"
                          [dataSource]="currencies"
                          [showClearButton]="true"
                          [showDropDownButton]="true"
                          [(value)]="model.currency"
                          valueChangeEvent="focusout"
                          (onValueChanged)="catalogUpdate($event)"
                          [readOnly]="readOnly('catalogPriceUnit')"
                        >
                        </dx-autocomplete>
                      </div>
                    </div>
                  </div>

                  <!-- Zeile 5 -->
                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(6)" (mouseleave)="ttt(6)">
                        {{ 'Länder' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt6"
                      >
                        <label class="placeLabel {{ model?.territories?.length>0 ? 'placeLabelSmall' : '' }}">TERRITORIES</label>

                        <dx-tag-box
                          [(value)]="model.territories"
                          [items]="territories"
                          placeholder=""
                          [acceptCustomValue]="true"
                          (onValueChanged)="catalogUpdate($event)"
                          [readOnly]="readOnly('catalogCountry')"
                        >
                        </dx-tag-box>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(15)" (mouseleave)="ttt(15)">
                        {{ 'Kurznote' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt15"
                      >
                        <label class="placeLabel {{ model.note?.length>0 ? 'placeLabelSmall' : '' }}">NOTE</label>

                        <dx-text-box
                          id="catalogNote"
                          [readOnly]="readOnly('catalogNote')"
                          [(value)]="model.note"
                          [showClearButton]="true"
                          (onValueChanged)="catalogUpdate($event)"
                        >
                        </dx-text-box>
                      </div>

                      <dx-tooltip target="#tt15" class="toolTip toolTipField" [(visible)]="v[15]">
                        <div *dxTemplate="let data = data of 'content'">
                          <p>{{ 'Kurz Notiz welche in der Catalogliste angezeigt wird' | translate }}.</p>
                        </div>
                      </dx-tooltip>
                    </div>
                  </div>

                  <!-- Zeile  -->
                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(5)" (mouseleave)="ttt(5)">
                        {{ 'Katalog Datum' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt5"
                      >
                        <label class="placeLabel {{ model.date?.length>0 ? 'placeLabelSmall' : '' }}">CATALOG_DATE</label>

                        <dx-date-box
                          id="date"
                          [readOnly]="readOnly('catalogDate')"
                          [(value)]="model.date"
                          displayFormat="dd.MM.yyyy"
                          type="date"
                          valueChangeEvent="focusout"
                          (onValueChanged)="catalogUpdate($event)"
                        >
                        </dx-date-box>
                      </div>

                      <dx-tooltip target="#tt5" class="toolTip toolTipField" [(visible)]="v[5]">
                        <div *dxTemplate="let data = data of 'content'">
                          <p>
                            {{ 'Ein Feld aus dem BMEcat' | translate }}.
                            {{ 'Es gibt an, wann der Katalog veröffentlicht wurde' | translate }}.
                          </p>
                          <div *ngIf="showProToolTips" class="nexMartTooltip">
                            {{ 'Technisch gibt es keine Besonderheiten' | translate }}.
                          </div>
                        </div>
                      </dx-tooltip>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(13)" (mouseleave)="ttt(13)">
                        {{ 'Sprache' | translate }}
                      </div>
                      <div class="dx-field-value" id="tt13">
                        <dx-autocomplete
                          [dataSource]="modelService.loginService.languageFlags"
                          displayExpr="text"
                          valueExpr="code"
                          [(value)]="model.language"
                          fieldTemplate="field"
                          (onValueChanged)="catalogUpdate($event)"
                          [readOnly]="readOnly('catalogLanguage')"
                        >
                        </dx-autocomplete>
                      </div>

                      <dx-tooltip target="#tt13" class="toolTip toolTipField" [(visible)]="v[13]">
                        <div *dxTemplate="let data = data of 'content'">
                          <p>
                            {{ 'Angabe der Sprache in der der Katalog gepflegt ist' | translate }}.
                            {{ 'Die Angabe sollte für BMEcat nach ISO-639-2 erfolgen' | translate }}.
                          </p>
                          <div *ngIf="showProToolTips" class="nexMartTooltip">
                            {{ 'Technisch gibt es keine Besonderheiten' | translate }}.
                          </div>
                        </div>
                      </dx-tooltip>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="dx-field">
                      <div class="dx-field-label dx-field-label200" (mouseenter)="ttt(14)" (mouseleave)="ttt(14)">
                        {{ 'Bearbeitungsnotiz' | translate }}
                      </div>
                      <div
                        class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}"
                        id="tt14"
                      >
                        <dx-html-editor
                          class="memoEditor"
                          [(value)]="model.memo"
                          placeholder="MEMO"
                          (onValueChanged)="catalogUpdate($event)"
                          [readOnly]="readOnly('catalogMemo')"
                          [minHeight]="120"
                          [maxHeight]="260"
                        >
                        </dx-html-editor>

                        <dx-tooltip target="#tt14" class="toolTip toolTipField" [(visible)]="v[14]">
                          <div *dxTemplate="let data = data of 'content'">
                            <p>
                              {{ 'Das Notiz Feld dient dazu, dass Sie sich Notizen zu diesem Katalog machen' | translate }}.
                              {{ 'Die Notizen bleiben nur in diesem Katalog. Kein Excel oder BMEcat Export' | translate }}:
                            </p>
                          </div>
                        </dx-tooltip>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!--Aggrement-->
              <div *ngIf="modelService.loginService.hasAddonAGREEMENT" class="dx-fieldset">
                <dx-accordion
                  class="agreementAccordion"
                  [dataSource]="agreementDummy"
                  [collapsible]="true"
                  [multiple]="false"
                  [animationDuration]="300"
                  [selectedItems]="emptyArray"
                >
                  <div *dxTemplate="let t of 'title'" class="dx-fieldset-header">
                    {{ 'Rahmenvertrag' | translate }}
                  </div>

                  <div *dxTemplate="let i of 'item'">
                    <div class="container-fluid px-0">
                      <div class="row g-3">

                        <!-- Beschreibung -->
                        <div class="col-12">
                          <div class="dx-field">
                            <div class="dx-field-label dx-field-label200">
                              {{ 'Beschreibung' | translate }}
                            </div>
                            <div class="dx-field-value">
                              <dx-text-box
                                [readOnly]="readOnly('catalogAggrementDESC')"
                                [(value)]="model.agreement.agreementDesc"
                                [showClearButton]="true"
                                valueChangeEvent="focusout"
                                (onValueChanged)="catalogUpdate($event)"
                              ></dx-text-box>
                            </div>
                          </div>
                        </div>

                        <!-- Vertrags ID -->
                        <div class="col-12 col-lg-6">
                          <div class="dx-field">
                            <div class="dx-field-label dx-field-label200">
                              {{ 'ID des Rahmenvertrags' | translate }}
                            </div>
                            <div class="dx-field-value">
                              <dx-text-box
                                [readOnly]="readOnly('catalogAggrementId')"
                                [(value)]="model.agreement.agreementId"
                                [showClearButton]="true"
                                valueChangeEvent="focusout"
                                (onValueChanged)="catalogUpdate($event)"
                              ></dx-text-box>
                            </div>
                          </div>
                        </div>

                        <!-- Vertragstyp -->
                        <div class="col-12 col-lg-6">
                          <div class="dx-field">
                            <div class="dx-field-label dx-field-label200">
                              {{ 'Rahmenvertragstyp' | translate }}
                            </div>
                            <div class="dx-field-value">
                              <dx-autocomplete
                                [minSearchLength]="0"
                                [dataSource]="['buyer','supplier']"
                                [showClearButton]="true"
                                [showDropDownButton]="true"
                                [(value)]="model.agreement.type"
                                valueChangeEvent="focusout"
                                (onValueChanged)="catalogUpdate($event)"
                                [readOnly]="readOnly('catalogAggrementType')"
                              ></dx-autocomplete>
                            </div>
                          </div>
                        </div>

                        <!-- Vertragsstart -->
                        <div class="col-12 col-lg-3">
                          <div class="dx-field">
                            <div class="dx-field-label dx-field-label200">
                              {{ 'Startzeitpunkt' | translate }}
                            </div>
                            <div class="dx-field-value">
                              <dx-date-box
                                [readOnly]="readOnly('catalogAggrementStartDate')"
                                [(value)]="model.agreement.startDate"
                                displayFormat="dd.MM.yyyy"
                                type="datetime"
                                valueChangeEvent="focusout"
                                (onValueChanged)="catalogUpdate($event)"
                              ></dx-date-box>
                            </div>
                          </div>
                        </div>

                        <!-- Vertragsende -->
                        <div class="col-12 col-lg-3">
                          <div class="dx-field">
                            <div class="dx-field-label dx-field-label200">
                              {{ 'Endzeitpunkt' | translate }}
                            </div>
                            <div class="dx-field-value">
                              <dx-date-box
                                [readOnly]="readOnly('catalogAggrementEndDate')"
                                [(value)]="model.agreement.endDate"
                                displayFormat="dd.MM.yyyy"
                                type="datetime"
                                valueChangeEvent="focusout"
                                (onValueChanged)="catalogUpdate($event)"
                              ></dx-date-box>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                </dx-accordion>
              </div>
            </div>
          </div>

          <!--Lieferant-->
          <div *dxTemplate="let company of 'lieferantTemplate'">
            <catalogSupplier></catalogSupplier>
          </div>

          <!--Käufer-->
          <div *dxTemplate="let company of 'kaeuferTemplate'">
            <catalogBuyer></catalogBuyer>
          </div>

          <!--Mimes-->
          <div *dxTemplate="let company of 'medienTemplate'">
            <mimes [(model)]="model.mimes"
                   [(showToolTips)]="showToolTips"
                   [(showProToolTips)]="showProToolTips"
                   [(showPlaceHolders)]="showPlaceHolders"
                   [(catalogId)]="modelService.catalogService.catalog.id"
                   [(customerId)]="modelService.loginService.currentUser.customerId"
                   (reloadNedded)="reload()"
                   (onValueChanged)="catalogUpdate()"
                   [(modelService)]="modelService">
            </mimes>
          </div>

          <!--Einstellungen-->
          <div *dxTemplate="let company of 'settingsTemplate'">
            <catalogSettings></catalogSettings>
          </div>

          <!--MedienPool-->
          <div *dxTemplate="let company of 'poolTemplate'">
            <mediaPool *ngIf="model"></mediaPool>
          </div>

          <!--DATA Quality-->
          <div *dxTemplate="let company of 'dataQualityTemplate'">
            <dataQuality *ngIf="model"></dataQuality>
          </div>

          <div *dxTemplate="let company of 'workflowPlansTemplate'">
            <workflow-plans #workflowPlansComponent></workflow-plans>
          </div>

        </dx-tab-panel>
      </div>
    </dx-validation-group>

    <dx-popup [width]="800"
              minHeight="550"
              [height]="'auto'"
              [showTitle]="true"
              title="{{ 'Katalog reimport' | translate }}"
              [dragEnabled]="false"
              [hideOnOutsideClick]="true"
              [(visible)]="importCatalogVisible"
              [showCloseButton]="true"
              contentTemplate="popupContent">
      <div *dxTemplate="let data of 'popupContent'">
        <importCatalog (onReimportCatalog)="hideImportCatalog()"></importCatalog>
      </div>
    </dx-popup>

    <dx-popup [width]="700"
              [height]="400"
              [showTitle]="true"
              title="{{ 'Übersetzung erstellen' | translate }}"
              [dragEnabled]="false"
              [showCloseButton]="true"
              [hideOnOutsideClick]="true"
              [(visible)]="modelService.catalogService.translateVisible"
              contentTemplate="popupContent">
      <div *dxTemplate="let data of 'popupContent'">
        <translateCatalog></translateCatalog>
      </div>
    </dx-popup>

    <export [(visible)]="exportVisible" [popupOpen] ="exportVisible"></export>

    <!-- Category Export PopUp -->
    <exportCategory [(visible)]="categoryExportVisible"></exportCategory>

    <!-- Category Import PopUp -->
    <dx-popup class="popup"
              [width]="800"
              [height]="450"
              [showTitle]="true"
              title="{{ 'Kategorien importieren' | translate }}"
              [dragEnabled]="false"
              [hideOnOutsideClick]="true"
              [(visible)]="categoryImportVisible"
              [showCloseButton]="true"
              contentTemplate="popupContent">
      <div *dxTemplate="let data of 'popupContent'">
        <importCategory [(visible)]="categoryImportVisible"></importCategory>
      </div>
    </dx-popup>

    <app-user-action-window [(visible)]="macroVisible" />
  </div>

</div>
